import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Divider,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import {
  Person as PersonIcon,
  Email as EmailIcon,
  Work as WorkIcon,
  VpnKey as VpnKeyIcon
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import ChangePassword from '../components/ChangePassword';

const UserProfile = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h5">Loading profile...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        User Profile
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card elevation={3}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
              <Avatar 
                sx={{ 
                  width: 100, 
                  height: 100, 
                  bgcolor: 'primary.main',
                  mb: 2,
                  fontSize: '2.5rem'
                }}
              >
                {user.username ? user.username.charAt(0).toUpperCase() : 'U'}
              </Avatar>
              <Typography variant="h5" gutterBottom>
                {user.username || 'User'}
              </Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                {user.role ? user.role.replace('_', ' ').toUpperCase() : 'User'}
              </Typography>
              <Divider sx={{ width: '100%', my: 2 }} />
              <List sx={{ width: '100%' }}>
                <ListItem>
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Full Name" 
                    secondary={user.fullName || user.username || 'Not specified'} 
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Email" 
                    secondary={user.email || 'Not specified'} 
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <WorkIcon />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Role" 
                    secondary={user.role ? user.role.replace('_', ' ').toUpperCase() : 'User'} 
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={8}>
          <Card elevation={3}>
            <CardHeader
              title="Security"
              avatar={<VpnKeyIcon color="primary" />}
            />
            <Divider />
            <Box sx={{ p: 3 }}>
              <ChangePassword />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserProfile;
